'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = require('bluebird');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Very simple version of a connection pool
 * Supports n number of connections
 */
var EthConnectionPool = function () {
  /**
   * @param {Array} connections - any service object to pool
   * @param {Number} delayMs - ms between checks
   */
  function EthConnectionPool(connections) {
    var delayMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

    _classCallCheck(this, EthConnectionPool);

    this.delay = delayMs;
    this.connections = connections.map(function (connection, id) {
      return {
        id: id,
        connection: connection,
        ready: true
      };
    });
  }

  /**
   * Wait until there's an available connection
   *
   * @return {Promise<*>} - returns promise of a connection
   */


  _createClass(EthConnectionPool, [{
    key: 'acquireConnection',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var availableConnection;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                availableConnection = void 0;

              case 1:
                availableConnection = this.connections.find(function (connection) {
                  return connection.ready;
                });

                if (availableConnection) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return (0, _bluebird.delay)(this.delay);

              case 5:
                if (!availableConnection) {
                  _context.next = 1;
                  break;
                }

              case 6:

                availableConnection.ready = false;
                return _context.abrupt('return', availableConnection);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function acquireConnection() {
        return _ref.apply(this, arguments);
      }

      return acquireConnection;
    }()

    /**
     * Send a function, once there's an available connection
     *
     * @param {Function} f - function to call with connection
     * @return {Promise} - result of f()
     */

  }, {
    key: 'withConnection',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(f) {
        var connection;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.acquireConnection();

              case 2:
                connection = _context2.sent;
                _context2.prev = 3;
                _context2.next = 6;
                return f(connection.connection);

              case 6:
                return _context2.abrupt('return', _context2.sent);

              case 7:
                _context2.prev = 7;

                connection.ready = true;
                return _context2.finish(7);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3,, 7, 10]]);
      }));

      function withConnection(_x2) {
        return _ref2.apply(this, arguments);
      }

      return withConnection;
    }()
  }]);

  return EthConnectionPool;
}();

exports.default = EthConnectionPool;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/EthConnectionPool.js
// module id = 1233
// module chunks = 0